import type { ReactNode } from 'react'

import styled from 'styled-components'

import type { helpers } from 'styles'

import { solidStyling } from './Solid'

type Props = {
	fullWidth?: boolean
	type?: keyof Omit<typeof helpers.color, 'status'>
	label: ReactNode
}

export const LinkSolidNative = styled.a.attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
